import { render, staticRenderFns } from "./activityGoods.vue?vue&type=template&id=3e3cf503&scoped=true&"
import script from "./activityGoods.vue?vue&type=script&lang=js&"
export * from "./activityGoods.vue?vue&type=script&lang=js&"
import style0 from "./activityGoods.vue?vue&type=style&index=0&id=3e3cf503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3cf503",
  null
  
)

export default component.exports